import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { VolumeService } from './volume.service'
import { SmartAppService } from './smart-app.service'
import { ChannelService } from './channel.service'
import { RouterService, RouterPage } from './router.service'
import { LocalAppLaunchMode } from '../interfaces/local-app'

@Injectable({
  providedIn: 'root',
})
export class EventService {
  keyDown: Subject<string> = new Subject<string>()

  constructor(
    private smartAppService: SmartAppService,
    private channelService: ChannelService,
    private routerService: RouterService,
    private volumeService: VolumeService
  ) {
    // do nothing
  }

  addEvent(event: string): void {
    switch (event) {
      case 'CHANNEL-UP':
        this.channelService.openChannelPage(this.channelService.getNextChannel())
        break
      case 'CHANNEL-DOWN':
        this.channelService.openChannelPage(this.channelService.getPreviousChannel())
        break
      case 'EXIT':
        this.routerService.goToHome()
        break
      case 'HOME':
        this.routerService.goToHome()
        break
      case 'INFO':
        this.routerService.goToPage(RouterPage.CHANNEL_GRID)
        break
      case 'NETFLIX':
        this.smartAppService.launchNetflix(LocalAppLaunchMode.REMOTE)
        break
      case 'VOL-MUTE':
        this.volumeService.switchVolumeMute()
        break
      case 'VOL-DOWN':
        this.volumeService.setVolumeDown()
        break
      case 'VOL-UP':
        this.volumeService.setVolumeUp()
        break
      default:
        this.keyDown.next(event)
        break
    }
  }
}
